const shifts = {
  toast: {
    error: {
      badResponse: '[Tasa] respuesta incorrecta del servidor',
    },
  },

  create: {
    errorToast: {
      message: 'Ocurrió un error. No se pudo crear el turno',
    },
    successToast: {
      message: '¡Éxito! Turno creado correctamente',
    },
  },

  delete: {
    errorToast: {
      message: 'Ocurrió un error. No se pudo eliminar el turno',
    },
    successToast: {
      message: '¡Éxito! turnos eliminados correctamente.',
    },
    confirmation: {
      header: 'Confirmación de eliminar turnos',
      body: {
        dynamic: 'Está a punto de eliminar {{numShifts}} turnos.',
        all: 'Está a punto de eliminar todos los turnos.',
      },
    },
  },

  edit: {
    errorToast: {
      message: 'Ocurrió un error. No se pudo actualizar turno',
    },
    successToast: {
      message: '¡Éxito! Turno actualizado correctamente',
    },
  },

  headerButtons: {
    create: 'Crear',
  },

  table: {
    headers: {
      name: 'Nombre',
      status: 'Estado',
      start: 'Início',
      end: 'Fin',
      year: 'Año',
      direction: 'Dirección',
      weekDays: 'semanaDías',
    },
    cells: {
      weekDays: {
        weekDaysOptions: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sab'],
      },
      status: {
        statusOptions: {
          statusActive: 'Activo',
          statusNotActive: 'No activo',
        },
      },
    },
    actions: {
      delete: 'Eliminar',
      export: 'Exportar',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },

  form: {
    header: {
      createShift: {
        title: 'Crear',
      },

      updateShift: {
        title: 'Actualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    information: {
      details: {
        header: 'Turno',
        fields: {
          name: 'Nombre',
          status: 'Estado',
          start: 'Início',
          end: 'Fin',
          year: 'Año',
          direction: 'Dirección',
          weekDays: 'Días de la semana',
        },
      },
      directionOptions: {
        selectDirection: 'Seleccionar dirección',
        from: 'Recoger',
        to: 'Distribuir',
        both: 'Recolectar & distribuir',
      },
    },
    validations: {
      name: {
        required: 'El nombre es obligatorio',
        name: '',
      },
      start: {
        required: 'El inicio es obligatorio',
        start: '',
      },
      end: {
        required: 'El final es obligatorio',
        end: '',
      },
      year: {
        required: 'El año es obligatorio',
        year: '',
      },
      direction: {
        required: 'Se requiere dirección',
        direction: '',
      },
      weekDays: {
        required: 'Debe seleccionar al menos un día',
        weekDays: '',
      },
    },
    notification: {
      overnight: 'La hora de finalización es anterior a la hora de inicio, lo que significa que la recogida será al día siguiente',
    },
  },
};

export default shifts;
